<template>
  <div class="content" ref="periodContainer" style="display: flex; height: 100%;">
    <aside class="periodLeft" :style="{ width: leftWidth + 'px' }">
      <CsimSchemaPeriodStep :model="model" @handleSetSchemaPeriod="handleSetSchemaPeriod" ref="CsimSchemaPeriodStep" />
    </aside>
    <div class="split-bar" @mousedown="startDrag">
      <button
        class="collapse-btn"
        @click.stop="toggleCollapseLeft"
        :disabled="collapseState === 'periodRight'"
        :title="collapseState === 'periodLeft' ? '回到中间' : '折叠左侧'"
      >
        <span v-if="collapseState === 'periodLeft'">&#8596;</span>
        <span v-else>&#8592;</span>
      </button>
      <button
        class="collapse-btn"
        @click.stop="toggleCollapseRight"
        :disabled="collapseState === 'periodLeft'"
        :title="collapseState === 'periodRight' ? '回到中间' : '折叠右侧'"
      >
        <span v-if="collapseState === 'periodRight'">&#8596;</span>
        <span v-else>&#8594;</span>
      </button>
    </div>
    <aside class="periodRight" :style="{ width: rightWidth + 'px' }">
      <CsimSchemaPeriodFormList :formList="model.formList" v-on="$listeners" ref="CsimSchemaPeriodFormList" />
    </aside>
  </div>
</template>
<script>
import CsimSchemaPeriodStep from "./CsimSchemaPeriodStep";
import CsimSchemaPeriodFormList from "./CsimSchemaPeriodFormList";

export default {
  name: "CsimSchemaPeriod",
  inheritAttrs: false,
  components: {
    CsimSchemaPeriodStep,
    CsimSchemaPeriodFormList,
  },
  props: {
    model: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      leftWidth: 0,
      rightWidth: 0,
      dragging: false,
      startX: 0,
      startWidth: 0,
      startRightWidth: 0,
      lastLeftWidth: 300,
      lastRightWidth: 300,
      containerWidth: 0,
      splitBarWidth: 6,
      collapseState: 'periodNone' // 'periodNone' | 'periodLeft' | 'periodRight'
    }
  },
  methods: {
    handleSetSchema(record) {
      this.model = record;
      this.$refs.CsimSchemaPeriodStep.handleSetSchema(record);
    },
    updateFormList(periodData) {
      this.$refs.CsimSchemaPeriodFormList.updateFormList(periodData);
    },
    handleSetSchemaPeriod(periodData) {
      this.$refs.CsimSchemaPeriodFormList.handleSetSchemaPeriod(periodData);
    },

    //----------------------------------------------------------------------------------
    startDrag(e) {
      // 折叠状态禁止拖动
      if (this.collapseState !== 'periodNone') return;
      this.dragging = true;
      this.startX = e.clientX;
      this.startWidth = this.leftWidth;
      this.startRightWidth = this.rightWidth;
      document.addEventListener("mousemove", this.onDrag);
      document.addEventListener("mouseup", this.stopDrag);
    },
    onDrag(e) {
      if (!this.dragging) return;
      const delta = e.clientX - this.startX;
      let newLeft = Math.max(40, Math.min(this.startWidth + delta, this.containerWidth - this.splitBarWidth - 40));
      let newRight = this.containerWidth - newLeft - this.splitBarWidth;
      if (newRight < 40) {
        newRight = 40;
        newLeft = this.containerWidth - this.splitBarWidth - 40;
      }
      this.leftWidth = newLeft;
      this.rightWidth = newRight;
    },
    stopDrag() {
      this.dragging = false;
      document.removeEventListener("mousemove", this.onDrag);
      document.removeEventListener("mouseup", this.stopDrag);
    },
    toggleCollapseLeft() {
      if (this.collapseState === 'periodLeft') {
        // 回到居中
        this.leftWidth = Math.floor((this.containerWidth - this.splitBarWidth) / 2);
        this.rightWidth = this.containerWidth - this.leftWidth - this.splitBarWidth;
        this.collapseState = 'periodNone';
      } else if (this.collapseState === 'periodNone') {
        // 折叠左侧
        this.lastLeftWidth = this.leftWidth;
        this.leftWidth = 40;
        this.rightWidth = this.containerWidth - this.leftWidth - this.splitBarWidth;
        this.collapseState = 'periodLeft';
      }
    },
    toggleCollapseRight() {
      if (this.collapseState === 'periodRight') {
        // 回到居中
        this.leftWidth = Math.floor((this.containerWidth - this.splitBarWidth) / 2);
        this.rightWidth = this.containerWidth - this.leftWidth - this.splitBarWidth;
        this.collapseState = 'periodNone';
      } else if (this.collapseState === 'periodNone') {
        // 折叠右侧
        this.lastRightWidth = this.rightWidth;
        this.rightWidth = 40;
        this.leftWidth = this.containerWidth - this.rightWidth - this.splitBarWidth;
        this.collapseState = 'periodRight';
      }
    },
    updateWidths() {
      const periodContainer = this.$refs.periodContainer;
      if (periodContainer) {
        this.containerWidth = periodContainer.offsetWidth;
        this.leftWidth = Math.floor((this.containerWidth - this.splitBarWidth) / 2);
        this.rightWidth = this.containerWidth - this.leftWidth - this.splitBarWidth;
        this.lastLeftWidth = this.leftWidth;
        this.lastRightWidth = this.rightWidth;
        this.collapseState = 'periodNone';
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.updateWidths();
      }, 0);
      window.addEventListener("resize", this.updateWidths);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateWidths);
  },
  watch: {
    loadState(val) {
      if (val) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.updateWidths();
          }, 0);
        });
      }
    }
  }
};
</script>

<style scoped>
.content {
  height: 100%;
  position: relative;
}
.periodLeft {
  background: white;
  height: 100vh;
  overflow: auto;
  padding: 10px;
  margin-bottom: 50px;
}
.periodRight {
  background: white;
  height: 100vh;
  overflow: auto;
  padding: 10px;
  margin-bottom: 50px;
}
.split-bar {
  width: 6px;
  cursor: ew-resize;
  background: #ddd;
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.collapse-btn {
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
  transition: background 0.2s;
  margin: 2px 0;
}
.collapse-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.collapse-btn:hover:enabled {
  background: #f0f0f0;
}
</style>
